// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__3ewxU","row":"Node_row__1fksK","label":"Node_label__2d2q0","footer":"Node_footer__3RaK2"};